import React, { useEffect, useState } from 'react';
import FeatherIcon from 'feather-icons-react';
import { useSelector } from 'react-redux';
import moment from "moment-timezone";
import { Link, NavLink, } from 'react-router-dom';
import { Tooltip, Row, Col, Spin, message, Modal, Image, Typography, Dropdown } from 'antd';
import './AttachmentDisplay.css';
// import ReactHtmlParser from 'react-html-parser';
import propTypes from 'prop-types';
import { Scrollbars } from 'react-custom-scrollbars';
import ComposeMail from './Compose';
import { MailDetailsWrapper, MessageAction, MessageDetails, MessageReply, } from './email-style';
import CustomHtmlParser from './CustomHtmlParser'
import { FetchAllAttendeeList } from '../../../Api/Services/CommonApiService'
import Heading from '../../../components/heading/heading';
import { Cards } from '../../../components/cards/frame/cards-frame';
import {
  moveToTrashFromInbox,
  moveToTrashFromSent,
  moveToTrashFromSpam,
  moveSpamToInbox,
  deleteEmailFromTrash, UpdateMailFromDB, FetchDetailspage
} from '../../../Api/Services/EmailApiSevices'
import { ForwardEmailIcon, ReplyAllEmailIcon, ReplyEmailIcon } from '../../../components/Icons/Icons';

const { Text } = Typography;

function Single({ detailsId, detailsPage, searchText, flagDetails, BulkFunction, typeOfPage, setDbMailId, setNaCTrigger, dbMailId, blukGroupid, setTypeOfPage, close, SendFunction, DraftFunction, TrashFunction, Comefrom }) {
  const { emailapiValues } = useSelector((state) => state.EmailData);
  const localData = useSelector((state) => state.localRedux);
  const ProfileData = localData.profile
  const profile = ProfileData
  const [detailsData, setDetailsData] = useState()
  const [isMailEditorOpen, setMailEditorStatus] = useState(false);
  const [replyToPopup, setReplytoPopup] = useState()
  const [forwardformat, setForwardformate] = useState()
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [allattendeeData, setAllattendeeData] = useState()
  const [previewAttachment, setPreviewAttachment] = useState(null);
  async function UserDetailsApi() {
    try {
      const data = await FetchAllAttendeeList()
      setAllattendeeData(data)
    }
    catch (error) {
      setAllattendeeData([])
      message.error(error)
    }
  }
  const convertTime = (timeStr, timeFormat) => {
    let hours;
    let minutes;
    let period;
    if (timeStr.toLowerCase().includes('am') || timeStr.toLowerCase().includes('pm')) {
      // Parse 12-hour time string
      const timeParts = timeStr.match(/(\d{1,2}):(\d{2})/);
      hours = parseInt(timeParts[1], 10);
      minutes = parseInt(timeParts[2], 10);
      period = timeStr.match(/(am|pm)/i)[0].toLowerCase();

      if (period === 'pm' && hours !== 12) {
        hours += 12;
      } else if (period === 'am' && hours === 12) {
        hours = 0;
      }
    } else {
      // Parse 24-hour time string
      const timeParts = timeStr.split(':');
      hours = parseInt(timeParts[0], 10);
      minutes = parseInt(timeParts[1], 10);
    }
    if (timeFormat === '12hrs' || timeFormat === '12-hour') {
      period = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12 || 12;
      return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')} ${period}`;
    }
    // No need for an else here because we return in the if above
    if (timeFormat === '24hrs' || timeFormat === '24-hour') {
      return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
    }
    throw new Error('Invalid time format specified');
  };
  const getattendeeFrom = (fromEmail, emailName, dataList) => {
    const user = dataList.find(u => u.email === fromEmail);
    const name = user?.name?.trim();
    const validData = name || emailName || fromEmail;
    return validData;
  };
  function formatDate(dateTime) {
    if (!dateTime || !profile?.timeZone) return "";
    const extractTimezoneName = (tzStr) => {
      const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
      return match ? match[1] : "";
    };
    const toTimezone = extractTimezoneName(profile.timeZone);
    if (!moment.tz.zone(toTimezone)) {
      console.warn("Invalid target time zone provided");
      return "";
    }
    let utcTime;
    if (emailapiValues?.emailType === 'Google') {
      utcTime = moment.parseZone(dateTime).utc();
    }
    else if (emailapiValues?.emailType === 'Outlook' || emailapiValues?.emailType === 'Zoho' || emailapiValues?.emailType === "Other Email") {
      utcTime = moment.utc(dateTime);
    }
    const converted = utcTime.clone().tz(toTimezone);
    const formattedDate = converted.format("MMMM D, YYYY");
    const timeFormat = profile?.timeFormat && profile?.timeFormat !== "" ? profile.timeFormat : "24hrs";
    const rawTime = converted.format("HH:mm");
    const formattedTime = convertTime(rawTime, timeFormat);
    return `${formattedDate}, ${formattedTime}`;
  }
  function normalizeEmailData(input) {
    const cleanString = (str) => str.trim().replace(/^["']|["']$/g, "");
    const parseEmail = (emailString) => {
      emailString = cleanString(emailString);
      const match = emailString.match(/(.*)<(.+)>/);
      if (match) {
        return {
          name: cleanString(match[1]),
          address: match[2].trim(),
        };
      }
      return {
        name: "",
        address: emailString,
      };
    };
    const normalizeField = (field) => {
      if (!field) return [];
      return field.split(",").map((item) => parseEmail(item.trim()));
    };
    const BodywithLinks = (data) => {
      const urlPattern = /(https?:\/\/[^\s]+)/g;
      const formattedMessage = data.replace(urlPattern, (url) => {
        const escapedUrl = encodeURIComponent(url);
        return `<a href="${escapedUrl}" target="_blank">${url}</a>`;
      });
      return formattedMessage.replace(/\n/g, '<br />');
    };
    const formattedFrom = parseEmail(input.from || "");
    const formattedTo = normalizeField(input.to || "");
    const formattedCc = normalizeField(input.cc || "");
    const formattedBcc = normalizeField(input.bcc || "");
    let bodyText = "";
    if (emailapiValues?.emailType === "Outlook") {
      bodyText = input ? input?.bodyContent ? input.bodyContent : "" : ""
    }
    else if (emailapiValues?.emailType === "Google" || emailapiValues?.emailType === "Zoho" || emailapiValues?.emailType === "Other Email") {
      bodyText = input ? (input?.htmlContent && input?.htmlContent !== "") ? input.htmlContent : input?.textContent ? BodywithLinks(input.textContent) : "" : ""
    }
    return {
      ...input,
      from: formattedFrom,
      to: formattedTo,
      cc: formattedCc,
      bcc: formattedBcc,
      body: bodyText,
    };
  }
  function normalizeEmailDataforOutlook(input) {
    let bodyText = "";
    if (emailapiValues?.emailType === "Outlook") {
      bodyText = input ? input?.bodyContent ? input.bodyContent : "" : ""
    }
    return {
      ...input,
      body: bodyText,
    };
  }
  async function getDetailsApi(detailsPage, detailsId) {
    try {
      const data = await FetchDetailspage(detailsId, detailsPage)
      if (data.code === 200) {
        let modifiedData;
        const originalData = data.data;
        if (emailapiValues?.emailType === 'Outlook') {
          modifiedData = normalizeEmailDataforOutlook(originalData)
        } else if (emailapiValues?.emailType === 'Google' || emailapiValues?.emailType === 'Zoho' || emailapiValues?.emailType === "Other Email") {
          modifiedData = normalizeEmailData(originalData);
        };
        const enrichedData = {
          ...modifiedData,
          from: {
            ...modifiedData.from,
            name: emailapiValues?.email === modifiedData?.from?.address ? `${profile?.firstName} ${profile?.lastName}` : getattendeeFrom(modifiedData?.from?.address, modifiedData?.from?.name, allattendeeData),
          },
          to: Array.isArray(modifiedData.to)
            ? modifiedData.to.map((toItem) => ({
              ...toItem,
              name: emailapiValues?.email === toItem?.address ? `${profile?.firstName} ${profile?.lastName}` : getattendeeFrom(toItem?.address, toItem?.name, allattendeeData),
            })) : modifiedData.to,
          cc: Array.isArray(modifiedData.cc)
            ? modifiedData.cc.map((ccItem) => ({
              ...ccItem,
              name: emailapiValues?.email === ccItem?.address ? `${profile?.firstName} ${profile?.lastName}` : getattendeeFrom(ccItem?.address, ccItem?.name, allattendeeData),
            })) : modifiedData.cc,
        };
        setDetailsData(enrichedData)
        if ((detailsPage === "INBOX" || detailsPage === "Spam") && Comefrom === "EmailPage") {
          let apicall;
          let updatedFlags = [...flagDetails];
          if (emailapiValues?.emailType === "Google") {
            if (updatedFlags.includes('UNREAD')) {
              apicall = true;
              updatedFlags = updatedFlags.filter(flag => flag !== 'UNREAD');
            }
          }
          if (emailapiValues?.emailType === "Outlook") {
            if (updatedFlags.includes("Unread")) {
              apicall = true;
              updatedFlags = updatedFlags.map(flag => (flag === 'Unread' ? 'Read' : flag));
            }
          }
          if (emailapiValues?.emailType === "Zoho" || emailapiValues?.emailType === "Other Email") {
            if (!updatedFlags.includes('\\Seen')) {
              apicall = true;
              updatedFlags.push('\\Seen');
            }
          }
          if (apicall) {
            try {
              const payload = {
                mailId: detailsId,
                flags: updatedFlags
              }
              await UpdateMailFromDB(payload, dbMailId);
              setDbMailId()
            } catch (dbError) {
              message.error(dbError);
            }
          }
        }
      }
    }
    catch (error) {
      message.error("The email you’re trying to open has been deleted or no longer exists. It may have been moved, archived, or permanently removed")
      if (Comefrom !== "Entity" && Comefrom !== "Entitys") {
        if (detailsPage === "INBOX") {
          setTypeOfPage("Inbox")
        } else {
          setTypeOfPage(detailsPage)
        }
        setDbMailId()
      }
    }
  }
  const MovetoTrash = async (trashIds, type) => {
    if (!trashIds) {
      message.info("Please select emails");
      return;
    }
    let hideMessage;
    Modal.confirm({
      icon: null,
      className: "customice-confirm-modal",
      title: "Delete confirmation",
      content: (
        <div>
          <p>Are you sure, you want to delete?</p>
        </div>
      ),
      centered: true,
      okText: "Delete",
      cancelText: "Cancel",
      okButtonProps: {
        className: "red_colorsModal"
      },
      cancelButtonProps: {
        className: "gray-buttonModal"
      },
      okCancel: true,
      onOk: async () => {
        const payload = {
          mailIds: [trashIds]
        }
        if (type === "INBOX") {
          hideMessage = message.loading("Moving to trash...", 0);
          try {
            await moveToTrashFromInbox(payload);
            // try {
            //   const payload = {
            //     mailId: trashIds,
            //     mailType: "Trash"
            //   }
            //   await UpdateMailFromDB(payload, dbMailId);
            //   setDbMailId()
            // } catch (error) {
            //   message.error(error);
            // }
            message.success('Email(s) moved to trash');
            setTypeOfPage("Inbox")
            hideMessage();
          } catch (error) {
            hideMessage();
            message.error(error);
          }
        }
        else if (type === "Sent") {
          hideMessage = message.loading("Moving to trash...", 0);
          try {
            await moveToTrashFromSent(payload)
            // try {
            //   const payload = {
            //     mailId: trashIds,
            //     mailType: "Trash"
            //   }
            //   await UpdateMailFromDB(payload, dbMailId);
            //   setDbMailId()
            // } catch (error) {
            //   message.error(error);
            // }
            message.success('Email(s) moved to trash');
            setTypeOfPage("Sent")
            hideMessage();
          } catch (error) {
            hideMessage();
            message.error(error);
          }
        }
        else if (type === "Bulk Email") {
          hideMessage = message.loading("Moving to trash...", 0);
          try {
            await moveToTrashFromSent(payload)
            // try {
            //   const payload = {
            //     mailId: trashIds,
            //     mailType: "Trash"
            //   }
            //   await UpdateMailFromDB(payload, dbMailId);
            //   setDbMailId()
            // } catch (error) {
            //   message.error(error);
            // }
            message.success('Email(s) moved to trash');
            BulkFunction(typeOfPage, "Bulk", 1, searchText)
            setTypeOfPage(typeOfPage)
            hideMessage();
          } catch (error) {
            hideMessage();
            message.error(error);
          }
        }
        else if (type === "Spam") {
          hideMessage = message.loading("Moving to trash...", 0);
          try {
            await moveToTrashFromSpam(payload)
            // try {
            //   const payload = {
            //     mailId: trashIds,
            //     mailType: "Trash"
            //   }
            //   await UpdateMailFromDB(payload, dbMailId);
            //   setDbMailId()
            // } catch (error) {
            //   message.error(error);
            // }
            message.success('Email(s) moved to trash');
            setTypeOfPage("Spam")
            hideMessage();
          } catch (error) {
            hideMessage();
            message.error(error);
          }
        }
      }
    });
  }
  const SpamtoInbox = async (trashIds) => {
    let hideMessage;
    if (trashIds) {
      const payload = {
        mailIds: [trashIds]
      }
      hideMessage = message.loading("Moving to Inbox...", 0);
      try {
        await moveSpamToInbox(payload)
        // try {
        //   const payload = {
        //     mailId: trashIds,
        //     mailType: "INBOX"
        //   }
        //   await UpdateMailFromDB(payload, dbMailId);
        // } catch (dbError) {
        //   message.error(dbError);
        // }
        setTypeOfPage("Spam")
        hideMessage();
      } catch (error) {
        hideMessage();
        message.error(error);
      }
    }
    else {
      message.info("Please select emails")
    }
  }
  const DeleteForEverFunction = async (trashIds) => {
    if (!trashIds) {
      message.info("Please select emails");
      return;
    }
    let hideMessage;
    Modal.confirm({
      icon: null,
      className: "customice-confirm-modal",
      title: "Delete confirmation",
      content: (
        <div>
          <p>Are you sure, you want to delete forever?</p>
        </div>
      ),
      centered: true,
      okText: "Delete",
      cancelText: "Cancel",
      okButtonProps: {
        className: "red_colorsModal"
      },
      cancelButtonProps: {
        className: "gray-buttonModal"
      },
      okCancel: true,
      onOk: async () => {
        const payload = {
          mailIds: [trashIds]
        }
        hideMessage = message.loading("Deleting from trash...", 0);
        try {
          await deleteEmailFromTrash(payload)
          // try {
          //   await DelteMailFromDB(dbMailId)
          //   setDbMailId()
          // } catch (error) {
          //   message.error(error);
          // }
          message.success('Email(s) deleted forever');
          setTypeOfPage("Trash")
          hideMessage();
        } catch (error) {
          hideMessage();
          message.error(error);
        }
      },
    });
  }
  useEffect(() => {
    UserDetailsApi()
  }, [])
  useEffect(() => {
    if (detailsId && allattendeeData) {
      getDetailsApi(detailsPage, detailsId);
    }
  }, [detailsId, detailsPage, allattendeeData]);
  const popupclose = () => {
    if (Comefrom === "Entitys" || Comefrom === "Entity") {
      setNaCTrigger("CallBack")
    } else {
      close()
    }
    setMailEditorStatus(false)
  }
  const toggleMailComposer = (value) => {
    const emailData = {
      date: detailsData ? detailsData.date : "",
      from: detailsData ? detailsData.from : "",
      to: detailsData ? detailsData.to : "",
      cc: detailsData ? detailsData.cc : "",
      subject: detailsData ? detailsData.subject !== "" && detailsData.subject ? detailsData.subject : "(No Subject)" : "(No Subject)",
      body: detailsData ? detailsData.body ? detailsData.body : "" : "",
      attachment: detailsData ? detailsData.attachments : [],
    };
    setMailEditorStatus(!isMailEditorOpen);
    setReplytoPopup(value)
    setForwardformate(emailData)
    if (Comefrom === "Entitys" || Comefrom === "Entity") {
      setNaCTrigger("trigger")
    }
  };
  const ForwardFunctionality = (value) => {
    const emailData = {
      date: detailsData ? detailsData.date : "",
      from: detailsData ? detailsData.from : "",
      to: detailsData ? detailsData.to : "",
      cc: detailsData ? detailsData.cc : "",
      subject: detailsData ? detailsData.subject !== "" && detailsData.subject ? detailsData.subject : "(No Subject)" : "(No Subject)",
      body: detailsData ? detailsData.body ? detailsData.body : "" : "",
      attachment: detailsData ? detailsData.attachments : [],
    };
    setMailEditorStatus(!isMailEditorOpen);
    setReplytoPopup(value)
    setForwardformate(emailData)
    if (Comefrom === "Entitys" || Comefrom === "Entity") {
      setNaCTrigger("trigger")
    }
  }
  const downloadAttachment = (attachment) => {
    const blob = new Blob([new Uint8Array(attachment.content.data)], { type: attachment.contentType });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = attachment.filename;
    link.click();
    URL.revokeObjectURL(link.href);
  };
  const shortenFilename = (filename, maxLength = 20) => {
    const extension = filename.substring(filename.lastIndexOf('.'));
    const nameWithoutExtension = filename.substring(0, filename.lastIndexOf('.'));
    if (nameWithoutExtension.length > maxLength) {
      return `${nameWithoutExtension.substring(0, maxLength)}...${extension}`;
    }
    return filename;
  };
  const showModal = (attachment) => {
    setPreviewAttachment(attachment);
    setIsModalVisible(true);
  };
  const handleCancel = () => {
    setIsModalVisible(false);
    setPreviewAttachment(null);
  };
  const renderPreview = (attachment) => {
    if (attachment.contentType.includes('image')) {
      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
          }}
        >
          <Image
            width="400px"
            height="auto"
            src={`data:${attachment.contentType};base64,${btoa(String.fromCharCode(...new Uint8Array(attachment.content.data)))}`}
            style={{ maxHeight: '400px', objectFit: 'contain' }}
          />
        </div>
      );
    }
    if (attachment.contentType.includes('pdf')) {
      const pdfBlob = new Blob([new Uint8Array(attachment.content.data)], { type: 'application/pdf' });
      const pdfUrl = URL.createObjectURL(pdfBlob);
      return <iframe src={pdfUrl} width="800px" height="600px" title="PDF Preview" />;
    }
    const text = new TextDecoder().decode(new Uint8Array(attachment.content.data));
    return (
      <div style={{ maxHeight: '400px', overflowY: 'auto', padding: '10px', background: '#f4f4f4', borderRadius: '4px' }}>
        <Text code>{text}</Text>
      </div>
    );
  };
  return (
    <>
      {Comefrom === "EmailPage" &&
        <div style={{
          lineHeight: "32px",
          padding: "19px 0px",
          height: "84px",
        }} className='email-top-search' />
      }
      <MailDetailsWrapper className={(Comefrom === "Entity" || Comefrom === "Entitys") ? 'Details-Emailcard' : 'Antd-email-Card'}>
        {detailsData ?
          <Cards className="email-detail-view" headless={(Comefrom === "Entity" || Comefrom === "Entitys")}
            title={Comefrom === "EmailPage" && (
              <>
                <MessageAction>
                  <Link onClick={() =>
                    setTypeOfPage(detailsPage === "INBOX" ? "Inbox" : detailsPage)}
                    to="#">
                    <FeatherIcon icon="arrow-left" size={14} />
                  </Link>
                  {detailsPage === "Trash" ?
                    <Tooltip placement="bottom" title="Delete Forever">
                      <NavLink to="/Home/email/inbox"
                        onClick={() => DeleteForEverFunction(detailsId)}
                      >
                        <FeatherIcon icon="trash" size={18} />
                      </NavLink>
                    </Tooltip>
                    :
                    <Tooltip placement="bottom" title="Delete">
                      <NavLink to="/Home/email/inbox" onClick={() => MovetoTrash(detailsId, detailsPage)}>
                        <FeatherIcon icon="trash" size={18} />
                      </NavLink>
                    </Tooltip>
                  }
                </MessageAction>
              </>)
            }
          >
            <Scrollbars
              autoHide
              autoHideTimeout={500}
              autoHideDuration={200}
              style={{ width: "100%", height: 842 }}
            >
              <Row gutter={15}>
                <Col span={24}>
                  <MessageDetails>
                    <div className="d-flex justify-content-between align-items-center" style={{ padding: "10px 0px 0px" }}>
                      <div className="message-subject">
                        <Heading as="h2">
                          {detailsData?.subject ? detailsData.subject : "(No Subject)"}
                          <span className="mail-badge primary" style={{ display: "flex", alignItems: "center", gap: 5 }}>{detailsPage === "INBOX" ? "Inbox" : detailsPage === "Bulk Email" ? "Bulk Email" : detailsPage} {detailsPage === "Spam" ? <FeatherIcon icon="x" size={12} style={{ cursor: "pointer" }} onClick={() => SpamtoInbox(detailsId)} /> : ""}</span>
                        </Heading>
                      </div>
                      <div className="message-action" />
                    </div>
                    <div className="message-box d-flex justify-content-between align-items-center">
                      <div className="message-author">
                        <span className='list_span_Tag' style={{ width: '60px', height: "60px", fontSize: "x-large", borderRadius: '50%' }}>
                          {detailsData?.from?.name?.trim() ? detailsData?.from?.name?.slice(0, 1).toUpperCase() : detailsData?.from?.address?.slice(0, 1).toUpperCase()}
                        </span>
                        <div>
                          <Heading as="h4">
                            {detailsData?.from?.name?.trim() ? detailsData.from.name : detailsData.from.address.split("@")[0]}
                            <span style={{ color: "#6c757d", marginLeft: 5, fontSize: 12 }}>&lt;{detailsData.from.address}&gt;</span>
                          </Heading>
                          <Dropdown
                            overlayClassName="MailInfoPopup"
                            placement="bottomLeft"
                            overlay={
                              <ul className="mail-props" style={{ marginBottom: 0 }}>
                                <li>
                                  <span>From :</span> <span>
                                    {detailsData?.from?.name?.trim() ? detailsData.from.name : detailsData.from.address.split("@")[0]}
                                    <span style={{ color: "#6c757d", marginLeft: 5 }}>&lt;{detailsData.from.address}&gt;</span>
                                  </span>
                                </li>
                                <li>
                                  <span>To :</span> <span>
                                    {detailsData?.to
                                      ?.map((item, index, array) => (
                                        <div key={index} style={{ color: "#6c757d", }}>
                                          {item?.name?.trim() ? `${item.name} <${item.address}>` : item.address}
                                          {index !== array.length - 1 && ","}
                                        </div>
                                      ))}
                                  </span>
                                </li>
                                <li>
                                  <span>CC :</span> <span>{detailsData?.cc
                                    ?.map((item, index, array) => (
                                      <div key={index} style={{ color: "#6c757d", }}>
                                        {item?.name?.trim() ? `${item.name} <${item.address}>` : item.address}
                                        {index !== array.length - 1 && ","}
                                      </div>
                                    ))}</span>
                                </li>
                                <li>
                                  <span>Date :</span> <span>{detailsData && formatDate(detailsData.date)}</span>
                                </li>
                              </ul>
                            }
                          >
                            <div
                              style={{
                                fontSize: 12,
                                marginLeft: 0,
                                display: "flex",
                                alignItems: "center",
                                color: "rgb(146, 153, 184)"
                              }}
                            >
                              <span style={{ marginRight: 5 }}>To</span>{detailsData?.to
                                ?.map((item) => (item.name?.trim() ? item.name.split(" ")[0] : item.address.split("@")[0])).join(", ")}
                              <FeatherIcon icon="chevron-down" size={14} />
                            </div>
                          </Dropdown>
                        </div>
                      </div>
                      <div className="message-excerpt">
                        <span> {detailsData && formatDate(detailsData.date)} </span>
                        <div style={{ marginRight: 10, color: "#5a5f7d" }}
                          className='Hover-Refresh2 back-hover1 able-style'
                          role="button"
                          tabIndex={0} title='Reply To'
                          onClick={() => toggleMailComposer("Reply To")}
                          onKeyDown={(event) => {
                            if (event.key === 'Enter' || event.key === ' ') {
                              toggleMailComposer("Reply To")
                            }
                          }}
                          aria-label='Reply To'
                        >  <ReplyEmailIcon height={14} width={14} /></div>
                        <div className='Hover-Refresh2 back-hover1 able-style'
                          role="button" style={{ marginRight: 10, color: "#5a5f7d" }}
                          tabIndex={0} title='Reply All'
                          onClick={() => toggleMailComposer("Reply All")}
                          onKeyDown={(event) => {
                            if (event.key === 'Enter' || event.key === ' ') {
                              toggleMailComposer("Reply All")
                            }
                          }}
                          aria-label='Reply All'
                        > <ReplyAllEmailIcon height={14} width={14} strokeWidth={10} /></div>
                      </div>
                    </div>
                    <div className="message-body">
                      <p><CustomHtmlParser html={detailsData?.body} key={1} disableInteractions={blukGroupid === "bulk"} /></p>
                    </div>
                    {detailsData?.attachments.length > 0 &&
                      <>
                        <div className="message-attachments" style={{ fontSize: 16, fontWeight: 600, marginBottom: 10 }}>
                          {detailsData?.attachments.filter((attachment) => attachment.contentDisposition === "attachment").length > 0 ?
                            `${detailsData?.attachments.filter((attachment) => attachment.contentDisposition === "attachment").length} Attachment(s)`
                            : ""}
                        </div>
                        <div className="message-attachments">
                          {detailsData?.attachments
                            .filter((attachment) => attachment.contentDisposition === "attachment")
                            .map((attachment, index) => (
                              <figure key={index} style={{ display: "flex", gap: 10, alignItems: "center" }}>
                                <div className="attachment-image">
                                  <img style={{ height: "50px" }}
                                    src={require('../../../static/img/defaultImages/justify.png')}
                                    alt={attachment?.filename}
                                  />
                                </div>
                                <figcaption style={{ flex: 1, marginTop: 0 }}>
                                  <div title={attachment?.filename} style={{
                                    cursor: "default",
                                    fontWeight: 700,
                                    fontSize: 14,
                                  }}>{attachment?.filename ? shortenFilename(attachment.filename, 20) : "No Name"}</div>
                                  <div style={{
                                    display: "flex", alignItems: "center", justifyContent: "flex-start",
                                    gap: '10px',
                                    marginTop: '5px',
                                  }}>
                                    <span style={{
                                      flexGrow: 0,
                                      fontSize: 12,
                                      fontWeight: 600,
                                    }}>{(attachment.size / 1024)?.toFixed(2)} KB
                                    </span>
                                    <span role="button" style={{
                                      fontSize: 12,
                                      fontWeight: 600,
                                      color: "#4183f1",
                                      cursor: "pointer",
                                      flexGrow: 0,
                                    }}
                                      tabIndex={0}
                                      onClick={() => downloadAttachment(attachment)}
                                      onKeyDown={(event) => {
                                        if (event.key === 'Enter' || event.key === ' ') {
                                          downloadAttachment(attachment)
                                        }
                                      }}>
                                      Download
                                    </span>
                                    <span role="button" style={{
                                      fontSize: 12,
                                      fontWeight: 600,
                                      color: "#4183f1",
                                      cursor: "pointer",
                                      flexGrow: 0,
                                    }}
                                      tabIndex={0}
                                      onClick={() => showModal(attachment)}
                                      onKeyDown={(event) => {
                                        if (event.key === 'Enter' || event.key === ' ') {
                                          showModal(attachment)
                                        }
                                      }}>
                                      View
                                    </span>
                                  </div>
                                </figcaption>
                              </figure>
                            ))}
                        </div>
                      </>
                    }
                  </MessageDetails>
                </Col>
              </Row>
              <Row gutter={15}>
                <Col xs={24}>
                  <MessageReply>
                    <nav>
                      <ul>
                        <li>
                          <div role="button" style={{ marginRight: 10, color: "#5a5f7d" }}
                            tabIndex={0} title='Reply All'
                            onClick={() => toggleMailComposer("Reply To")}
                            onKeyDown={(event) => {
                              if (event.key === 'Enter' || event.key === ' ') {
                                toggleMailComposer("Reply To")
                              }
                            }}
                            aria-label='Reply All'
                          > <ReplyEmailIcon height={14} width={14} marginRight={5} /> Reply
                          </div>
                        </li>
                        <li>
                          <div role="button" style={{ marginRight: 10, color: "#5a5f7d" }}
                            tabIndex={0} title='Reply All'
                            onClick={() => toggleMailComposer("Reply All")}
                            onKeyDown={(event) => {
                              if (event.key === 'Enter' || event.key === ' ') {
                                toggleMailComposer("Reply All")
                              }
                            }}
                            aria-label='Reply All'
                          >
                            <ReplyAllEmailIcon height={14} width={14} strokeWidth={10} marginRight={5} /> Reply All
                          </div>
                        </li>
                        <li>
                          <div role="button" style={{ marginRight: 10, color: "#5a5f7d" }}
                            tabIndex={0} title='Reply All'
                            onClick={() => ForwardFunctionality("Forward")}
                            onKeyDown={(event) => {
                              if (event.key === 'Enter' || event.key === ' ') {
                                ForwardFunctionality("Forward")
                              }
                            }}
                            aria-label='Reply All'
                          >
                            <ForwardEmailIcon height={14} width={14} marginRight={5} /> Forward
                          </div>
                        </li>
                      </ul>
                    </nav>
                  </MessageReply>
                </Col>
              </Row>
            </Scrollbars>
          </Cards >
          :
          <div className="spin">
            <Spin />
          </div>
        }
      </MailDetailsWrapper >
      <ComposeMail mailOpen={isMailEditorOpen} entity="MailPage" Comefrom={Comefrom} setNaCTrigger={setNaCTrigger} close={popupclose} SendFunction={SendFunction} searchText={searchText} DraftFunction={DraftFunction} TrashFunction={TrashFunction} replyToPopup={replyToPopup} detailsPage={detailsPage} forwardformatss={forwardformat} setDetailsData={setForwardformate} />
      {
        isModalVisible && <Modal
          title={previewAttachment?.filename}
          open={isModalVisible}
          onCancel={handleCancel}
          footer={false}
          width={1000}
        >
          {previewAttachment && renderPreview(previewAttachment)}
        </Modal>
      }
    </>
  );
}

Single.propTypes = {
  setDbMailId: propTypes.func,
  dbMailId: propTypes.number,
  detailsId: propTypes.number,
  detailsPage: propTypes.string,
  flagDetails: propTypes.array,
  Comefrom: propTypes.string,
  BulkFunction: propTypes.func,
  setTypeOfPage: propTypes.func,
  close: propTypes.func,
  SendFunction: propTypes.func,
  DraftFunction: propTypes.func,
  searchText: propTypes.string,
  TrashFunction: propTypes.func,
  blukGroupid: propTypes.string,
  typeOfPage: propTypes.string,
  setNaCTrigger: propTypes.func,
};

export default Single;
